import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function RecoveryErrorStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "recovery-error-heading", children: [_jsx("h3", { id: "recovery-error-heading", children: t('recovery.error.heading') }), _jsx("p", { children: t('recovery.error.body') }), _jsx("p", { "aria-label": t('recovery.error.detail_aria_label'), children: _jsx("small", { children: t('recovery.error.detail_template', {
                        code: props.code,
                        detail: props.message,
                    }) }) }), _jsx("button", { type: "button", onClick: props.onRestart, children: t('recovery.error.try_again') })] }));
}
//# sourceMappingURL=error-step.js.map